export const environment = {
  production: true,
  title: '',
  authUrl: '#{authUrl}#',
  apiUrl: '#{apiUrl}#',
  spaUrl: '#{spaUrl}#'
};
